import { connectorClient } from "@connector/connectorClient";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const connectorKeys = {
  list: (sessionKey: string) => ["connectors", sessionKey] as const,
};

// Status changes server-side (Updating… → Connected); `AdminShell` keeps the panel mounted, so this polls all admin session.
const CONNECTORS_REFETCH_MS = 30_000;

/** Non-suspense: lives inside the Connect panel's cards and is gated on profile-select. */
export const useConnectorsList = (sessionKey: string, enabled: boolean) =>
  useQuery({
    queryKey: connectorKeys.list(sessionKey),
    queryFn: connectorClient.listConnectors,
    enabled,
    refetchInterval: CONNECTORS_REFETCH_MS,
  });

export const useMintPairingCode = () =>
  useMutation({
    mutationFn: connectorClient.mintPairingCode,
    // PairingCodeCard renders the failure inline, so the global notice stays quiet.
    meta: { handled: true },
  });

export const useUnpairConnector = (sessionKey: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: connectorClient.unpair,
    meta: { action: "unpair the connector" },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: connectorKeys.list(sessionKey),
      }),
  });
};
